import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "@/hooks/useTranslation";
import { useState } from "react";

const Industries = () => {
  const t = useTranslation();
  const industries = [{
    title: t.industries.manufacturing,
    categories: [t.industries.categories.industrialMachinery, t.industries.categories.threeDPrinting, t.industries.categories.roboticSolutions],
    image: "https://bepnmmikbflhezryppcs.supabase.co/storage/v1/object/public/pictures1/Industry-images/Manufacturing-robots.jpg"
  }, {
    title: t.industries.infrastructure,
    categories: [t.industries.categories.energy, t.industries.categories.dataCenters, t.industries.categories.governmentFacilities],
    image: "https://bepnmmikbflhezryppcs.supabase.co/storage/v1/object/public/pictures1/Industry-images/aerial-energy_2.jpg"
  }, {
    title: t.industries.warehouses,
    categories: [t.industries.categories.distributionCenters, t.industries.categories.coldStorage, t.industries.categories.microFulfillment],
    image: "https://bepnmmikbflhezryppcs.supabase.co/storage/v1/object/public/pictures1/Industry-images/Warehouse_2.jpg"
  }, {
    title: t.industries.supplyChain,
    categories: [t.industries.categories.retail, t.industries.categories.foodAndAgriculture, t.industries.categories.logisticsAndTransportation],
    image: "https://bepnmmikbflhezryppcs.supabase.co/storage/v1/object/public/pictures1/Industry-images/aerial-port_cointainers_2.jpg"
  }];
  const [imageErrors, setImageErrors] = useState<Record<number, boolean>>({});

  const handleImageError = (index: number) => {
    setImageErrors(prev => ({ ...prev, [index]: true }));
  };

  const handleImageLoad = (index: number) => {
    setImageErrors(prev => ({ ...prev, [index]: false }));
  };

  return <section className="py-12 relative">
      <div className="container px-4 sm:px-6 lg:px-8 mx-auto relative">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-flex items-center justify-center px-3 py-1 mb-4 rounded-full bg-accent/10 border border-accent/20">
            <span className="text-xs font-semibold tracking-[0.2em] text-accent uppercase">
              Verticals
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t.industries.title}</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((industry, index) => <Card key={index} className="glass-card hover:bg-background/80 hover:border-accent/20 transition-all duration-300 hover:shadow-lg hover:translate-y-[-4px] group rounded-xl overflow-hidden">
              <div className="aspect-[4/3] relative bg-muted">
                {!imageErrors[index] ? (
                <img 
                    src={industry.image} 
                    alt={industry.title} 
                    width="400"
                    height="300"
                    className="object-cover w-full h-full transition-opacity duration-300" 
                    loading={index < 2 ? "eager" : "lazy"}
                    fetchPriority={index < 2 ? "high" : "low"}
                    decoding="async"
                    onLoad={() => handleImageLoad(index)}
                    onError={() => handleImageError(index)}
                    style={{ 
                      backgroundColor: 'hsl(var(--muted))',
                      minHeight: '200px'
                    }}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-muted">
                    <div className="flex flex-col items-center gap-2 text-muted-foreground">
                      <span className="text-sm">{industry.title}</span>
                    </div>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              </div>
              <CardContent className="p-6">
                <div className="mb-4">
                  <h3 className="text-xl font-medium">{industry.title}</h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {industry.categories.map((category, idx) => <span key={idx} className="text-sm px-2 py-1 bg-white/5 rounded-full text-muted-foreground">
                      {category}
                    </span>)}
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
};
export default Industries;